import type { MultiSelectOption } from "@/components/ui/MultiSelect";
import { SUPRIMENTOS_KANBAN_KAMBAR_PATTERN } from "@/config/constants";

export function findKambarCostCenterIds(options: MultiSelectOption[]): string[] {
  const ids: string[] = [];
  for (const o of options) {
    const label = String(o.label ?? "");
    const value = String(o.value ?? "").trim();
    if (!value) continue;
    if (SUPRIMENTOS_KANBAN_KAMBAR_PATTERN.test(label) || SUPRIMENTOS_KANBAN_KAMBAR_PATTERN.test(value)) {
      ids.push(value);
    }
  }
  return ids;
}

export function kambarFilterLabel(options: MultiSelectOption[], ids: string[]): string {
  if (ids.length === 0) return "Kambar";
  const labels = ids
    .map((id) => options.find((o) => o.value === id)?.label ?? id)
    .filter(Boolean);
  return labels[0] ?? "Kambar";
}
